import type { SupabaseClient } from '@supabase/supabase-js';
import type { GuestRelationshipLink } from '../../types';

/** Uložení páru hostů s konzistentním pořadím (stejné jako CHECK v DB). */
export function normalizeGuestPair(a: string, b: string): [string, string] {
  return a < b ? [a, b] : [b, a];
}

export const DEFAULT_GUEST_RELATIONSHIP_LABELS_CS = [
  'Partneři / pár',
  'Manželé',
  'Rodinní příslušníci',
  'Přátelé',
  'Kolegové',
  'Jiné',
] as const;

export const DEFAULT_GUEST_RELATIONSHIP_LABELS_EN = [
  'Partners / couple',
  'Spouses',
  'Family',
  'Friends',
  'Colleagues',
  'Other',
] as const;

type LocaleCode = 'cs' | 'en';

export function defaultRelationshipLabelsForLocale(locale: LocaleCode): string[] {
  return locale === 'en'
    ? [...DEFAULT_GUEST_RELATIONSHIP_LABELS_EN]
    : [...DEFAULT_GUEST_RELATIONSHIP_LABELS_CS];
}

/**
 * Pokud svatba nemá žádný typ vazby, vloží výchozí štítky (jednorázově).
 */
export async function ensureDefaultGuestRelationshipTypes(
  supabase: SupabaseClient,
  weddingId: string,
  locale: LocaleCode,
): Promise<void> {
  const { count, error: countErr } = await supabase
    .from('guest_relationship_types')
    .select('*', { count: 'exact', head: true })
    .eq('wedding_id', weddingId);

  if (countErr) {
    console.warn('guest_relationship_types count:', countErr.message);
    return;
  }

  if ((count ?? 0) > 0) return;

  const labels = defaultRelationshipLabelsForLocale(locale);
  const rows = labels.map((label, sort_order) => ({
    wedding_id: weddingId,
    label,
    sort_order,
  }));

  const { error } = await supabase.from('guest_relationship_types').insert(rows);
  if (error) {
    console.warn('ensureDefaultGuestRelationshipTypes:', error.message);
  }
}

export function otherGuestIdFromLink(link: { guest_low_id: string; guest_high_id: string }, viewerId: string): string {
  return link.guest_low_id === viewerId ? link.guest_high_id : link.guest_low_id;
}

export function linksForGuest(links: GuestRelationshipLink[], guestId: string): GuestRelationshipLink[] {
  return links.filter((l) => l.guest_low_id === guestId || l.guest_high_id === guestId);
}
